//Function to open/close the footer prices
const footerFunction = () => {
  const opener = document.querySelector(
    'div[aria-label="Shopping cart"] .cart__item--total',
  );
  opener.addEventListener("click", () => {
    const switcher = document.querySelector(".em-0014-container");

    switcher.classList.toggle("active");
  });
};

//initial
footerFunction();
